<!-- 集控器下变量管理 -->
<template>
    <div class='container containerBox'>
        <!-- 头部筛选区 -->
        <div class="handleForm">
            <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="设备">
                    <el-select v-model="form.device" placeholder="请选择设备" @change="handleChangePLC">
                        <el-option
                            v-for="item in deviceList"
                            :key="item.oid"
                            :label="item.device_model+'：'+item.terminal_serial"
                            :disabled="item.dev_type != 4"
                            :value="item.oid">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="模块分组">
                    <el-select v-model="form.setting_type" placeholder="请选择模块" @change="handleChangeVar">
                        <el-option
                            v-for="item in machineVarConfig"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </div>

        <!-- <div style="float:left;width:100px;">
            <el-tabs tab-position="left" style="height: 100%;">
                <el-tab-pane label="温度配置"></el-tab-pane>
                <el-tab-pane label="设备工况"></el-tab-pane>
                <el-tab-pane label="频率设置"></el-tab-pane>
                <el-tab-pane label="故障设置"></el-tab-pane>
                <el-tab-pane label="压差设置"></el-tab-pane>
                <el-tab-pane label="延时配置"></el-tab-pane>
            </el-tabs>
        </div> -->
        <div>
            <template v-if="form.setting_type !== 5">
                <ul key="1">
                    <li v-for="(v, index) in var_list" :key="index" style="margin-bottom:10px;">
                        <el-row :gutter="20" v-if="!v.hidden">
                            <el-col :span="5">
                                <el-input v-model="v.label" placeholder="请输入label"></el-input>
                            </el-col>
                            <el-col :span="9">
                                <el-select style="width:100%" v-model="v.newaddr" filterable placeholder="请选择addr" @change="handleChangeAddr">
                                    <el-option
                                        v-for="item in tableData"
                                        :key="item.oid"
                                        :label="item.var_name+' : '+item.var_Initial_addr"
                                        :value="item.oid">
                                    </el-option>
                                </el-select>
                            </el-col>
                           <el-col :span="5">
                                <!-- <el-input v-model="v.prop" placeholder="请输入prop"></el-input> -->
                            </el-col>
                            <el-col :span="5">
                                <el-button type="danger" size="medium" icon="el-icon-delete" @click="hanldeDelete(v, index)"></el-button>
                                <el-button type="primary" size="medium" icon="el-icon-caret-top" @click="hanldeSortUp(v, index)"></el-button>
                                <el-button type="success" size="medium" icon="el-icon-caret-bottom" @click="hanldeSortDown(v, index)"></el-button>
                            </el-col>
                        </el-row>
                    </li>
                </ul>
            </template>
            <!-- 故障 -->
            <template v-if="form.setting_type === 5">
                <ul key="2">
                    <li v-for="(v, index) in var_faultList" :key="index" style="margin-bottom:10px;">
                        <el-row :gutter="20">
                            <el-col :span="5">
                                <el-input v-model="v.name" placeholder="请输入label"></el-input>
                            </el-col>
                            <el-col :span="9">
                                <el-select style="width:100%" v-model="v.newaddr" filterable placeholder="请选择addr">
                                    <el-option
                                        v-for="item in tableData"
                                        :key="item.oid"
                                        :label="item.var_name+' : '+item.var_Initial_addr"
                                        :value="item.oid">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="5">
                                <el-input v-model.number="v.error_value" placeholder="请输入error_value">{{}}</el-input>
                            </el-col>
                            <el-col :span="5">
                                    <el-button type="danger" size="medium" icon="el-icon-delete" @click="hanldeDelete(v, index)"></el-button>
                                    <el-button type="primary" size="medium" icon="el-icon-caret-top" @click="hanldeSortUp(v, index)"></el-button>
                                <el-button type="success" size="medium" icon="el-icon-caret-bottom" @click="hanldeSortDown(v, index)"></el-button>
                            </el-col>
                        </el-row>
                    </li>
                </ul>
            </template>

            <el-button size="small" @click="handleAddRow">增加一行</el-button>
            <el-button size="small" @click="handleSave">保存</el-button>
        </div>

    </div>
</template>

<script>
import Service from '@/api/Service'


const swapArray = function (arr, index1, index2) {
   arr[index1] = arr.splice(index2, 1, arr[index1])[0];
    return arr;
}

export default {
    name:  'argmana',
    data() {
        return {
            form: {
                device: '',
                setting_type: 1,
            },

            deviceList: [], // 设备列表
            tableData: [], //   变量列表

            var_list: [],
            var_faultList: [],  //故障
           
            machineVarConfig: [],
            ServerRoom: [],
            oid: '',

        };
    },

    components: { },

    computed: {},

    mounted() {
        
    },

    async created() {
        await this.getDeviceList();
        await this.getMachineVarConfig();
        this.getServerRoombypid();
    },

    methods: {
        
        async getDeviceList() {
            let params = Object.assign({}, { page_num: 1, page_sum: 40 });
            let data = await Service.getMeter(params);
            if(data) {
                let list = data.list == null ? [] : data.list;
                this.deviceList = list;
                
            }
        },
        async getMachineVarConfig() {
            let res = await Service.getMachineVarConfig()
            this.machineVarConfig = res;
        },
        async getServerRoombypid() {
            let res = await Service.getServerRoombypid();
            res = res === "success" ? [] : res;
            if(res.length>0) {
                this.ServerRoom = res;
                // 默认第一台
                this.form.device = this.deviceList[0].oid
                this.handleChangePLC(this.deviceList[0].oid);
            }
        },
        async handleChangePLC(terminal_id) {
            let params = {
                terminal_id,
                page_num: 1,
                page_sum: 500,
            }
            let res = await Service.getPlcConfig(params);
            if(res) {
                let list = res.list === null ? [] : res.list;
                this.tableData = list;
                this.handleChangeVar(this.form.setting_type)
            }
        },
        handleChangeAddr(addr) {
            // let obj = this.tableData.filter(v=>{return addr === v.oid})[0]
            // if(obj.bytes>1) {
            //     // 双字节
            //     this.var_list.push({
            //         label: obj.var_name,
            //         addr: obj.var_Initial_addr+1, 
            //         prop: '',
            //         hidden: true,
            //     });
            // }
        },
        handleChangeVar(val) {
            let data = this.ServerRoom.filter(v=>v.setting_type === val && v.terminal_id === this.form.device)[0];
            if(data) {
                this.oid = data.oid
                this.form.device = data.terminal_id
                if(val == 5) {
                    this.var_faultList = JSON.parse(data.setting_data)
                }else{
                    this.var_list = JSON.parse(data.setting_data).map(v=>{
                        if(v.hidden === undefined) {
                            v.hidden = false;
                        }
                        return v
                    });
                }
            }else{
                this.oid = 0
                this.var_list = [];
                this.var_faultList = [];
            }
        },
        handleAddRow() {
            if(this.form.setting_type === 5) {
                this.var_faultList.push({
                    name: '', 
                    addr: '', 
                    error_value: ''
                });
                return
            }
            this.var_list.push({
                label: '',
                addr: '', 
                prop: ''
            });
        },
        hanldeDelete(v, index) {
            if(this.form.setting_type === 5) {
                this.var_faultList.splice(index, 1); 
            }else{
                let obj = this.tableData.filter(v1=>{return v.addr === v1.var_Initial_addr})[0]
                if(obj && obj.bytes>1) {
                    // 双字节
                     this.var_list.splice(index, 2); 
                }else{
                     this.var_list.splice(index, 1); 
                }
            }
        },
        // 上移
        hanldeSortUp(v, index) {
            if(index != 0){
                if(this.form.setting_type === 5) {
                    swapArray(this.var_faultList, index, index-1);
                }else{
                   swapArray(this.var_list, index, index-1);
                }
            }else{
                return
            }
        },
        // 下移
        hanldeSortDown(v, index) {
            if(this.form.setting_type === 5) {
                if(index+1 != this.var_faultList.length){
                    swapArray(this.var_faultList, index, index+1);
                }
            }else{
                if(index+1 != this.var_list.length){
                    swapArray(this.var_list, index, index+1);
                }
            }
        },
        async handleSave() {
			//选择故障设置的话初始化页面
			if(this.form.setting_type == 5) {
			    this.handleFalutSave();
			    return
			}
            let res
            if(this.oid == '') {
                // 新增
				for(var i = 0;i<this.var_list.length;i++){
					delete this.var_list[i].hidden
					this.var_list[i].prop = JSON.stringify(i)
					let obj = this.tableData.filter(v=>{return this.var_list[i].newaddr === v.oid})[0]
					if(obj){
						this.var_list[i].addr= obj.var_Initial_addr
						this.var_list[i].opcode= obj.opcode
					}
				}
                let newArr = this.var_list
                let arr = [...newArr]
                let params = {
                    terminal_id: this.form.device,
                    setting_data: JSON.stringify(arr),
                    setting_type: this.form.setting_type
                }
                res = await Service.addServerroom(params);
            }else{
                // 编辑
				for(var j = 0;j<this.var_list.length;j++){
					delete this.var_list[j].hidden
					this.var_list[j].prop = JSON.stringify(j)
					let obj = this.tableData.filter(v=>{return this.var_list[j].newaddr === v.oid})[0]
					if(obj){
						this.var_list[j].addr= obj.var_Initial_addr
						this.var_list[j].opcode= obj.opcode
						
					}
				}
				
                let params = {
                    oid: this.oid,
                    setting_data: JSON.stringify(this.var_list),
                }
                res = await Service.editServerroom(params);
            }
            if(res) {
                this.$message({
                    type: 'success',
                    message: '操作成功!'
                });
            }
        },
        async handleFalutSave() {
            let res
            if(this.oid == '') {
				for(var i = 0;i<this.var_faultList.length;i++){
					delete this.var_faultList[i].hidden
					this.var_faultList[i].prop = JSON.stringify(i)
					let obj = this.tableData.filter(v=>{return this.var_faultList[i].newaddr === v.oid})[0]
					if(obj){
						this.var_faultList[i].addr= obj.var_Initial_addr
						this.var_faultList[i].opcode= obj.opcode
					}
				}
				let newArr = this.var_faultList
				let arr = [...newArr]
                // 新增
                let params = {
                    terminal_id: this.form.device,
                    setting_data: JSON.stringify(this.var_faultList),
                    setting_type: this.form.setting_type
                }
                res = await Service.addServerroom(params);
            }else{
                // 编辑
				for(var j = 0;j<this.var_faultList.length;j++){
					delete this.var_faultList[j].hidden
					this.var_faultList[j].prop = JSON.stringify(j)
					let obj = this.tableData.filter(v=>{return this.var_faultList[j].newaddr === v.oid})[0]
					if(obj){
						this.var_faultList[j].addr= obj.var_Initial_addr
						this.var_faultList[j].opcode= obj.opcode
						
					}
				}
                let params = {
                    oid: this.oid,
                    setting_data: JSON.stringify(this.var_faultList),
                }
                res = await Service.editServerroom(params);
            }
            if(res) {
                this.$message({
                    type: 'success',
                    message: '操作成功!'
                });
                this.getServerRoombypid()
            }
        }
    }
}

</script>
<style lang='less' scoped>
    
</style>

